import React from 'react';
import _ from 'lodash';

import { useReturnAuthorizationSelectFieldQuery } from 'generated/graphql';



export interface IReturnAuthorization {
  id: string;
  name: string;
}

export interface IData {
  objects: IReturnAuthorization[];
}

export function useQuery(storeId: string) {
  const tuple = useReturnAuthorizationSelectFieldQuery({
    variables: {
      storeId
    }
  });

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(tuple.data?.returnAuthorizations.nodes ?? [], (node): IReturnAuthorization => ({
        id: node.id,
        name: node.returnNumber
      }))
    };

    return {
      loading: tuple.loading,
      data,
      refetch: async () => {
        tuple.refetch({});
      }
    };
  }, [tuple]);

  return wrappedTuple;
}
